import { Injectable } from '@angular/core';
import { TranslateDefaultParser } from '@ngx-translate/core';

@Injectable()
export class VbTranslateParser extends TranslateDefaultParser {
	public templateMatcher = /{\s?([^{}\s]*)\s?}/g;
}
